import Enhancer from '../enhancer';
import EnhancerApp from '../enhancer-app';
import { wrapElement } from '../utils/dom';

export default class ArticleBody extends Enhancer {

    init() {

        // Make youtube videos responsive
        this.getAll('iframe[src*="youtube"],iframe[src*="youtu.be"],iframe[src*="vimeo"]').forEach(video => {
            const wrapper = video.parentNode;
            video.classList.add('embed-item');
            wrapper.classList.add('embed-responsive');
            wrapper.classList.add('embed-responsive-16by9');
        });

        this.getAll('table').forEach(table => {
            const wrapper = table.parentNode;

            if (wrapper.classList.contains('table-responsive')) {
                return;
            }

            // create table wrapper
            const tableWrapper = document.createElement('div');
            tableWrapper.className = 'table-responsive';

            wrapElement(table, tableWrapper);
        });

    }

}

EnhancerApp.register('ArticleBody', ArticleBody);